import { apiCall } from "../../../services/api-service";

export const getVehicleDetailAPI = (id) =>
  apiCall("get", `get_vehicle_details/${id}`);

export const submitAPI = (body) =>
  apiCall("post", "expense_history", body);

export const UpdateAPI = (body, id) =>
  apiCall("put", `expense_history/${id}`, body);

export const getExpenseDetAPI = (id) =>
  apiCall("get", `expense_history/edit/${id}`);

export const viewExpenseDetAPI = (id) =>
  apiCall("get", `expense_history/view/${id}`);
